export const GROWLER_KEYS = {
  // Add to cart success
  ADDED_TO_CART_HEADLINE: 'GROWLER_ADDED_TO_CART_HEADLINE',
  ITEM_LINE: 'GROWLER_ITEM_LINE',

  // Coupon added
  COUPON_ADDED_HEADLINE: 'COUPON_ADDED_HEADLINE',

  // Selections unavailable / background updated (top-of-cart)
  SELECTIONS_UNAVAILABLE_TITLE: 'GROWLER_SELECTIONS_UNAVAILABLE_TITLE',
  SELECTIONS_UNAVAILABLE_MESSAGE: 'GROWLER_SELECTIONS_UNAVAILABLE_MESSAGE',

  // In-order alert
  SELECTIONS_UPDATED_TITLE: 'GROWLER_SELECTIONS_UPDATED_TITLE',
  UNAVAILABLE_ADDONS_MESSAGE: 'GROWLER_UNAVAILABLE_ADDONS_MESSAGE',
  UNAVAILABLE_BG_MESSAGE: 'GROWLER_UNAVAILABLE_BG_MESSAGE',

  // Prices updated (top-of-cart)
  PRICES_UPDATED_TITLE: 'GROWLER_PRICES_UPDATED_TITLE',
  PRICES_UPDATED_MESSAGE: 'GROWLER_PRICES_UPDATED_MESSAGE',

  // Prices updated (in-order)
  PRICING_UPDATED_SUBJECT_TITLE: 'GROWLER_PRICING_UPDATED_SUBJECT_TITLE',
  PRICING_UPDATED_SUBJECT_MESSAGE: 'GROWLER_PRICING_UPDATED_SUBJECT_MESSAGE',

  // Personalization (top-of-cart)
  PERSONALIZATION_NEEDED_TITLE: 'GROWLER_PERSONALIZATION_NEEDED_TITLE',
  PERSONALIZATION_NEEDED_MESSAGE: 'GROWLER_PERSONALIZATION_NEEDED_MESSAGE',

  // Personalization (in-order)
  PERSONALIZATION_REQUIRED_TITLE: 'GROWLER_PERSONALIZATION_REQUIRED_TITLE',
  PERSONALIZATION_REQUIRED_MESSAGE: 'GROWLER_PERSONALIZATION_REQUIRED_MESSAGE',

  // single/two students use ADDED_TO_CART_HEADLINE; 3+ use this key
  COPY_SUCCESS_ALL_STUDENTS_HEADLINE: 'GROWLER_COPY_SUCCESS_ALL_STUDENTS_HEADLINE',

  // Copy order failures
  COPY_FAILED_SINGLE_TITLE: 'GROWLER_COPY_FAILED_SINGLE_TITLE',
  COPY_PARTIAL_FAILED_SINGLE_TITLE: 'GROWLER_COPY_PARTIAL_FAILED_SINGLE_TITLE',
  COPY_FAILED_MULTIPLE_TITLE: 'GROWLER_COPY_FAILED_MULTIPLE_TITLE',
  COPY_PARTIAL_FAILED_MULTIPLE_TITLE: 'GROWLER_COPY_PARTIAL_FAILED_MULTIPLE_TITLE',
  COPY_FAILED_MESSAGE: 'GROWLER_COPY_FAILED_MESSAGE',
  COPY_PARTIAL_FAILED_MESSAGE: 'GROWLER_COPY_PARTIAL_FAILED_MESSAGE',

  // Auto-fill Name & Grade (top-of-cart)
  AUTOFILL_FAILED_TITLE: 'GROWLER_AUTOFILL_FAILED_TITLE',
  AUTOFILL_FAILED_MESSAGE: 'GROWLER_AUTOFILL_FAILED_MESSAGE',

  // Auto-fill Name & Grade (in-order)
  NAME_REQUIRED_TITLE: 'GROWLER_NAME_REQUIRED_TITLE',
  NAME_REQUIRED_MESSAGE: 'GROWLER_NAME_REQUIRED_MESSAGE'
} as const;
